import React from 'react';
import PropTypes from 'prop-types';
import CoachingAgendaCard from 'components/dashboard/CoachingAgendaCard';
import {List} from 'immutable';
import './RecentMeetingsColumn.styl';
import {browserHistory} from 'react-router';
import AuthStore from 'stores/AuthStore';
import DashboardHistoryActions from 'actions/dashboard/DashboardHistoryActions';
import {reviewPath} from 'components/dashboard/reviewPath';

export default class RecentMeetingsColumn extends React.PureComponent {
  render() {
    const {plans = List()} = this.props;
    // This component only deals with adhoc & livecoaching plans so we can assume every plan has
    // a single review
    const recentPlans = plans
      .filter(p => p.unscheduled())
      .sort((a, b) => a.completedAt.isBefore(b.completedAt))
      .take(3);

    return (
      <div className="recent-meetings-column agenda-column">
        <h4 className="column-header">Recent Reviews</h4>
        {recentPlans.map(p => (
          <CoachingAgendaCard
            key={p.id}
            rep={p.recipient.info}
            pendingType="READY"
            review={p.reviews.first()}
            onClick={() => {
              const pathname = reviewPath(AuthStore.getState().user);
              browserHistory.push({
                pathname,
                query: {
                  planId: p.id,
                  repId: p.recipient.id,
                  reviewId: p.reviews.first().id,
                },
              });
              DashboardHistoryActions.pushHistory(pathname);
            }}
            suppressEdit
            suppressHover
            plans={plans}
          />
        ))}
      </div>
    );
  }
}

RecentMeetingsColumn.propTypes = {
  plans: PropTypes.instanceOf(List), // List<CoachingPlan>
};
